module.exports = __webpack_public_path__ + "img/4.cc5e3994.png";